<template>
  <b-modal
    :active="active"
    has-modal-card
    @close="$emit('close')"
    :can-cancel="['escape', 'x', 'outside']"
  >
    <form @submit.prevent="validateBeforeSubmit">
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">
            {{ $t('compScenarioRuleParameterModal.title') }}
          </p>
        </header>
        <section class="modal-card-body">
          <b-notification :closable="false">
            {{ translate('level2help') }}
          </b-notification>
          <b-field
            v-for="(key, index) in level2keys"
            :key="index"
            :label="translate(key)"
            :type="{ 'is-danger': errors.has(key) }"
            :message="getErrorMsg(errors.first(key))"
          >
            <b-select
              v-if="rule.isUnique(key)"
              v-model="uniqueValues[key]"
              @input="setUniqueValue($event, key)"
              expanded
            >
              <option
                v-for="option in optionsValues(key)"
                :value="option.id"
                :key="option.id"
              >
                {{ $t(option.label) }}
              </option>
            </b-select>
            <treeselect
              v-else
              :name="key"
              :limit="5"
              :limitText="
                (count) =>
                  $t('compScenarioRuleParameterModal.and') +
                  ' ' +
                  count +
                  ' ' +
                  $t('compScenarioRuleParameterModal.more')
              "
              icon="caret-right"
              v-validate="{
                required: rule.hasSibblings()
              }"
              v-model="values[key]"
              :multiple="true"
              :placeholder="$t('add')"
              :options="optionsValues(key)"
            >
              <template slot="option-label" slot-scope="{ node }">{{
                $t(node.raw.label) | truncate(60)
              }}</template>
              <template slot="value-label" slot-scope="{ node }">{{
                $t(node.raw.label) | truncate(20)
              }}</template>
            </treeselect>
          </b-field>
        </section>
        <footer class="modal-card-foot buttons is-right">
          <nav class="level">
            <div class="level-left"></div>
            <div class="buttons level-right">
              <b-button class="button" @click="resetLevel2" icon-left="close">
                {{ $t('reset') }}
              </b-button>
              <button type="submit" class="button is-primary">
                <span class="icon is-small"><i class="fa fa-cog"></i></span>
                <span> {{ $t('apply') }} </span>
              </button>
            </div>
          </nav>
        </footer>
      </div>
    </form>
  </b-modal>
</template>

<script>
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import Rule from '../../models/scenario/Rule'
import Vue from 'vue'

export default {
  name: 'RuleParameterModal',
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    rule: {
      type: Object,
      default: null
    }
  },
  components: {
    treeselect: () => import('@riophae/vue-treeselect')
  },
  data () {
    return {
      values: {},
      uniqueValues: {}
    }
  },
  computed: {
    level2keys: function () {
      let level2keys = []
      for (let param of Object.keys(this.rule.level2)) {
        if (this.rule.getLevel2Values(param).length > 1) {
          level2keys.push(param)
        }
      }
      return level2keys
    },
    optionsValues: function () {
      return (key) => {
        return this.rule.getDynamicLevel2Objects(key)
      }
    }
  },
  methods: {
    setUniqueValue: function (value, key) {
      this.values[key][0] = value
    },
    getErrorMsg: function (value) {
      if (value) {
        return this.$t('compScenarioRuleParameterModal.error-1')
      } else {
        return ''
      }
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateLevel2()
        }
      })
    },
    translate (key) {
      return Rule.translate(this.rule, key, this.$i18n.locale)
    },
    resetLevel2 () {
      this.$emit('reset-level2', {
        id: this.rule.id,
        module: this.rule.module
      })
    },
    updateLevel2 () {
      this.$emit('update-level2', {
        id: this.rule.id,
        module: this.rule.module,
        values: this.values
      })
    },
    initValues () {
      if (this.rule.hasLevel2Parameters) {
        for (let key of Object.keys(this.rule.level2)) {
          Vue.set(this.values, key, this.rule.level2[key].value)
          Vue.set(this.uniqueValues, key, this.rule.level2[key].value[0])
        }
      }
    }
  },
  watch: {
    active: {
      handler () {
        this.initValues()
      },
      deep: true
    }
  },
  mounted () {
    this.initValues()
  }
}
</script>

<style scoped>
.modal-card,
.modal-card-body {
  overflow: visible !important;
}
</style>

<style>
.vue-treeselect__multi-value-item {
  background-color: hsl(0deg, 0%, 96%);
  color: hsl(0deg, 0%, 29%);
  font-size: 0.75rem;
}
.vue-treeselect__value-remove {
  color: hsl(0deg, 0%, 100%);
  border-radius: 10px;
  padding-left: 5px;
  background-color: hsla(0, 0%, 4%, 0.2);
}
.vue-treeselect__multi-value-item:hover {
  cursor: text;
}
.vue-treeselect__multi-value-item:hover > .vue-treeselect__value-remove {
  color: hsl(0deg, 0%, 100%) !important;
  cursor: pointer;
}
.vue-treeselect__value-remove:hover {
  color: hsl(0deg, 0%, 100%) !important;
  background-color: hsla(0, 0%, 4%, 0.3);
}
</style>
